<template>
    <form v-on:keyup.enter="submit" action="" @submit.prevent="submit" novalidate>
        <div class="contact-us-modal-title">
          צור קשר
        </div>
        <div class="wrapper-contact-us-form">
          <div class="form-inline">
              <div class="floating-input-wrapper">
                  <input v-model="first_name" type="text" name="first_name" class="floating-input" required>
                  <span v-bind:class="errors.first_name ? 'label-error floating-label' : 'floating-label'">
                      שם פרטי
                      <span class="required-star">*</span>
                  </span>
              </div>
              <div class="floating-input-wrapper">
                  <input v-model="last_name" type="text" name="first_name" class="floating-input" required >
                  <span v-bind:class="errors.last_name ? 'label-error floating-label' : 'floating-label'">
                      שם משפחה
                      <span class="required-star">*</span>
                  </span>
              </div>
          </div>
          <div class="form-inline">
              <div class="floating-input-wrapper">
                  <input v-model="phone" type="text" name="phone" class="floating-input" required>
                  <span v-bind:class="errors.phone ? 'label-error floating-label' : 'floating-label'">
                      מס' טלפון
                      <span class="required-star">*</span>
                  </span>
              </div>
              <div class="floating-input-wrapper">
                  <input v-model="email" type="text" name="email" class="floating-input" required>
                  <span v-bind:class="errors.email ? 'label-error floating-label' : 'floating-label'">
                      כתובת מייל
                      <span class="required-star">*</span>
                  </span>
              </div>
          </div>
          <textarea v-model="comment" type="text" name="message" placeholder="הודעתך"></textarea>
          <button type="submit" class="btn-submit">שלח</button>
        </div>
        <div class="success-send-form" style="display: none;">פנייתך התקבלה, נחזור אליך בהקדם!</div>
    </form>
</template>

<style>
.success-send-form {
  color: #00B6EB;
  text-align: center;
  margin-top: 10px;
  font-size: 24px;
  font-weight: 700;
  padding-bottom: 50px;
}

.btn-submit-disabled {
  background: #9a9a9a;
  pointer-events: none;
}
</style>

<script>
import axios from 'axios';

export default {
    name: "FooterContact",
    components: {
    },
    computed: {},
    data() {
        return {
            email: '',
            first_name: '',
            last_name: '',
            comment: '',
            phone: '',
            errors: [],
        }
    },
    beforeMount() {

    },
    methods: {
        submit() {
            document.querySelector('.btn-submit').classList.add('btn-submit-disabled');
            axios.post('/appeal/submit', {
                id: this.id,
                email: this.email,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: this.phone,
                comment: this.comment,
            })
                .then((response) => {
                    this.id = '';
                    this.email = '';
                    this.first_name = '';
                    this.last_name = '';
                    this.phone = '';
                    this.comment = '';
                  document.querySelector('.wrapper-contact-us-form').style.display = 'none';
                  document.querySelector('.success-send-form').style.display = 'block';
                  setTimeout(function () {
                    document.querySelector('.btn-submit').classList.remove('btn-submit-disabled');
                    document.querySelector('.success-send-form').style.display = 'none';
                    document.querySelector('.wrapper-contact-us-form').style.display = 'block';
                  }, 5000);
                })
                .catch((e) => {
                    document.querySelector('.btn-submit').classList.remove('btn-submit-disabled');
                    this.errors = e.response.data.errors;
                })
        },
    }
}
</script>

<style scoped>

</style>
